<template>
	<div
		:class="componentClassName"
		:style="{ '--size': `${size}px` }"
	>
		<slot
			v-if="slotName"
			:name="slotName"
		></slot>

		<div
			v-else-if="includeDot"
			class="status-dot"
		/>

		<span class="c-pill">{{ label }}</span>
	</div>
</template>

<script lang="ts" setup>
	import { toRefs, computed } from 'vue';

	export interface IPillProps {
		label?: string;
		pillNoBackgroundColor?: boolean;
		status?: string;
		size?: number;
		slotName?: string;
		includeDot?: boolean;
		lightVersion?: boolean;
	}

	const props = withDefaults(defineProps<IPillProps>(), {
		size: 12,
		slotName: null,
		includeDot: true,
		lightVersion: true,
	});

	const { label, pillNoBackgroundColor, status, size, slotName, includeDot, lightVersion } = toRefs(props);

	const componentClassName = computed(() => {
		let className = 'pill-container';

		if (status.value == 'warning') className += ' c-pill--warning';
		else if (status.value == 'error') className += ' c-pill--danger';
		else if (status.value == 'success') className += ' c-pill--success';
		else if (status.value == 'info' || (status.value != 'warning' && status.value != 'error' && status.value != 'success')) className += ' c-pill--info';

		if (lightVersion.value) className += ' light-version';
		if (pillNoBackgroundColor.value) className += ' c-pill--no-background';
		return className;
	});
</script>
